// This component styling is a HOT MESS

import React from 'react';
import PropTypes from 'prop-types';
import deburr from 'lodash/deburr';
import Autosuggest from 'react-autosuggest';
import match from 'autosuggest-highlight/match';
import parse from 'autosuggest-highlight/parse';
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import MenuItem from '@material-ui/core/MenuItem';
import Popper from '@material-ui/core/Popper';
import { withStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';

import './SearchBar.css';

let globoTimeout;

function renderInputComponent(inputProps) {
  const { classes, inputRef = () => {}, ref, ...other } = inputProps;

  return (
    <TextField
      fullWidth
      variant="outlined"
      className="search-hack"
      id="search-input-detail"
      InputProps={{
        inputRef: node => {
          ref(node);
          inputRef(node);
        },
        classes: {
          input: classes.input,
        },
      }}
      {...other}
    />
  );
}
  
function getGyms(query) {
  const inputValue = deburr(query.trim()).toLowerCase();
  const inputLength = inputValue.length;
  let count = 0;

  this.setState({
    localLoad: true
  })

  fetch('https://us-central1-btwb-thewire.cloudfunctions.net/' + 
    process.env.REACT_APP_API_PREFIX + 
    'LeaderboardSearchName?q=' + 
    query + 
    '&leaderboard_ids=' + 
    this.props.leaderboardId + 
    ',' + 
    this.props.backupLeaderboardId, 
  {
    method: 'GET'
  }).then(res => {
    return res.json();
  }).then(response => {
    return this.setState({
      localLoad: false,
      suggestions: inputLength === 0
    ? []
    : response.Standings.filter(suggestion => {
        const keep = count < 5;

        if (keep) {
          count += 1;
        }

        return keep;
      })
    });
  });
}

function getSuggestions(value, token) {
  window.clearTimeout(globoTimeout);

  const inputValue = deburr(value.trim()).toLowerCase();
  // const inputLength = inputValue.length;
  // let count = 0;

  return globoTimeout = window.setTimeout(getGyms.bind(this, inputValue, token), 500);
}

function getSuggestionValue(suggestion) {
  return suggestion.FullName;
}

const styles = theme => ({
  root: {
    padding: '1rem',
    width: '100%',
    position: 'absolute',
    background: '#fff',
    transition: '0.2s all',
    overflow: 'hidden',
    zIndex: 4
  },
  container: {
    position: 'relative',
  },
  suggestionsContainerOpen: {
    position: 'absolute',
    zIndex: 1,
    marginTop: theme.spacing.unit,
    left: 0,
    right: 0,
  },
  suggestion: {
    display: 'block',
  },
  suggestionsList: {
    margin: 0,
    padding: 0,
    listStyleType: 'none',
  }
});

class IntegrationAutosuggest extends React.Component {
  state = {
    single: '',
    popper: this.props.currentValue ? this.props.currentValue : '',
    suggestions: [],
  };

  // get our suggestions
  handleSuggestionsFetchRequested = ({ value }) => {
    getSuggestions.call(this, value)
    this.setState({
      suggestions: getSuggestions.call(this, value),
    });
  };

  // clear out our suggestions
  handleSuggestionsClearRequested = () => {
    this.setState({
      suggestions: [],
    });
  };

  // Suggestions actually visible
  renderSuggestion = (suggestion, { query, isHighlighted }) => {

    const matches = match(suggestion.FullName, query);
    const parts = parse(suggestion.FullName, matches);
    const hackArray = suggestion.PlaceOrdinal.toString().split('');
    const finalPlacement = (hackArray[hackArray.length - 2] ? hackArray[hackArray.length - 2] : '') + hackArray[hackArray.length - 1];


    return (
      <MenuItem 
        selected={isHighlighted} 
        id={'id-' + Math.floor(suggestion.PlaceOrdinal / 100)} 
        data-goto={parseInt(finalPlacement)}
        component="div">
        <div id={suggestion.id}>
          {parts.map((part, index) => {
            return part.highlight ? (
              <span key={String(index)} style={{ fontWeight: 500 }}>
                {part.text}
              </span>
            ) : (
              <strong key={String(index)} style={{ fontWeight: 300 }}>
                {part.text}
              </strong>
            );
          })}
        </div>
      </MenuItem>
    );
  }

  onSuggestionSelected = (event, { suggestion, suggestionValue, suggestionIndex, sectionIndex, method }) => {
    const hackArray = suggestion.PlaceOrdinal.toString().split('');
    const finalPlacement = (hackArray[hackArray.length - 2] ? hackArray[hackArray.length - 2] : '') + hackArray[hackArray.length - 1];

    let searchElement = document.getElementById('search-input-detail');

    searchElement.setAttribute('readonly', 'readonly'); // Force keyboard to hide on input field.
    searchElement.setAttribute('disabled', 'true'); // Force keyboard to hide on textarea field.
    setTimeout(function() {
        searchElement.blur();  //actually close the keyboard
        // Remove readonly attribute after keyboard is hidden.
        searchElement.removeAttribute('readonly');
        searchElement.removeAttribute('disabled');
    }, 100);

    searchElement.blur();

    this.closeSearch();
    
    this.props.updatePage(Math.floor(suggestion.PlaceOrdinal / 100), undefined, finalPlacement, suggestion.LeaderboardId, suggestion.DivisionId);
  }

  // This is our actual handler when a name is selected
  handleChange = name => (event, { newValue, method }) => {

    this.setState({
      [name]: newValue,
    });
  };

  componentWillReceiveProps(nextProps) {
    
    if(nextProps.currentValue !== this.props.currentValue) {
      return this.setState({
        popper: nextProps.currentValue
      })
    }

    if(nextProps.showing) {
      const elementToFocus = document.getElementById('search-input-detail');
      elementToFocus.focus();
    }
  }

  closeSearch = () => {
    this.props.hideSearch();
    this.setState({
      popper: ''
    })
  }

  render() {
    const { classes } = this.props;

    const autosuggestProps = {
      renderInputComponent,
      suggestions: Array.isArray(this.state.suggestions) ? this.state.suggestions : [],
      onSuggestionsFetchRequested: this.handleSuggestionsFetchRequested,
      onSuggestionsClearRequested: this.handleSuggestionsClearRequested,
      getSuggestionValue,
      renderSuggestion: this.renderSuggestion,
      onSuggestionSelected: this.onSuggestionSelected
    };

    return (
      <div 
        className={'transform-center ' + classes.root + ' ' + (this.props.showing ? 'show-it' : '')}
        style={{
          width: this.props.showing ? '100%' : '0%',
          left: this.props.showing ? '50%' : '100%',
          padding: this.props.showing ? '1rem' : '0'
        }}>
        <div 
          className={'absolute toggle-off'}
          onClick={this.closeSearch}>
          <i className="fas fa-times black"></i>
        </div>
        {this.state.localLoad &&
          <div className="search-load black absolute"><CircularProgress size={24} /></div>
        }
        
        <Autosuggest
          {...autosuggestProps}
          inputProps={{
            classes,
            label: this.state.single,
            placeholder: 'Search Athlete',
            value: this.state.popper,
            onChange: this.handleChange('popper'),
            inputRef: node => {
              this.popperNode = node;
            },
            InputLabelProps: {
            },
          }}
          theme={{
            suggestionsList: classes.suggestionsList,
            suggestion: classes.suggestion,
          }}
          renderSuggestionsContainer={options => (
            <Popper anchorEl={this.popperNode} open={Boolean(options.children)} style={{zIndex: 4}}>
              <Paper
                square
                {...options.containerProps}
                style={{ width: this.popperNode ? this.popperNode.clientWidth : null }}
              >
                {options.children}
              </Paper>
            </Popper>
          )}
        />
      </div>
    );
  }
}

IntegrationAutosuggest.propTypes = {
  classes: PropTypes.object.isRequired,
  updatePage: PropTypes.func.isRequired,
  currentValue: PropTypes.string,
  leaderboardId: PropTypes.number.isRequired,
  backupLeaderboardId: PropTypes.number.isRequired,
  toggleSearch: PropTypes.func.isRequired,
  hideSearch: PropTypes.func.isRequired,
  showing: PropTypes.bool.isRequired
};

export default withStyles(styles)(IntegrationAutosuggest);